<!-- MTKのヘッダー -->
<template>
  <div class="header">
    利用するチケットを選択してください
    <span @click="returnNativeApp()">×</span>
  </div>
</template>

<script>
export default {
  name: "MTKHeader",
};
</script>

<style lang="scss" scoped>
.header {
  padding: 15px;
  font-size: 0.8rem;
  border-bottom: 1px solid #e0e0e0;
  span {
    float: right;
    margin-right: 2vw;
    margin-top: -3px;
    color: #d5d5d5;
    font-size: 1rem;
  }
}
</style>
